import React, { Component } from 'react'
import 'rc-slider/assets/index.css'
import styles from './App.scss'
import { Route, Switch, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  getHeaderMode,
  getLockBackground,
  getFileManager
} from '@/store/getters'
import { setLocale } from '@/store/actions'
import AuthComponent from './auth/AuthComponent'
import LoginComponent from './auth/login/LoginComponent'
import checkAuth from './auth/checkAuth/checkAuth'
import { AuthGuard } from './auth/AuthGuard'
import FileManager from './fileManager/FileManagerComponent'
import LockBackground from './commons/LockBackground'
// import ContextMenu from './commons/ContextMenu'
import { CoreContext } from '@/contexts/core'
import { Resources } from '@/resources'
import { getLanguageUrl } from '@/constants'
import { LocaleStorage } from '@/storage'
import MagazinePreview from './publish/preview/MagazinePreview'
import MobilePublishComponent from './publish/MobilePublishComponent'
import PublishComponent from './publish/PublishComponent'



/** Components */
import HeaderComponent from '@/components/Heade'
import Toast from '@/components/Toast'
import AlertModal from '@/components/AlertModal'
import Scripts from './Scripts'

/** Pages */
import Dashboard from '@/pages/Dashboard'
import Editor from '@/pages/Editor'
import FirstMagazine from '@/pages/FirstMagazine'
import PageNotFound from '@/pages/PageNotFound'
import Welcome from '@/pages/Welcome'
import ExportedMagazines from '@/pages/ExportedMagazines'

const isMobile = require('ismobilejs')

class App extends Component {
  constructor(props) {
    super(props)

    // this.alerts = React.createRef()
    this.onPressedKey = this.onPressedKey.bind(this)
    this.langeResource = new Resources()
  }

  /**
   * ADD LISTENERS FOR KEYS THAT ARE PRESSED
   */
  componentDidMount() {
    window.pressedKeys = {}
    window.addEventListener('keydown', this.onPressedKey)
    window.addEventListener('keyup', this.onPressedKey)

    const defaultLang = LocaleStorage.getDefaultLanguage()

    if (defaultLang) {
      this.changeLanguage(defaultLang.code)
    } else {
      this.changeLanguage('en_us')
    }
  }

  /**
   * WHEN COMPONENT WAS UNMOUNT
   */
  componentWillUnmount() {
    window.removeEventListener('keydown', this.onPressedKey)
    window.removeEventListener('keyup', this.onPressedKey)
  }

  /**
   * When press any key
   * @param {Event} e
   */
  onPressedKey(e) {
    const event = e || window.event
    window.pressedKeys[e.which] = event.type === 'keydown' ? true : false
  }

  /**
   * CHANGE THE LANGUAGE
   */
  changeLanguage(code) {
    // IF ALREADY HAS A LANGUAGE ON LOCALSTORAGE
    /*const hasLang = LocaleStorage.getLanguageLoaded( code )
    if ( hasLang ) {
      this.props.setLocale( hasLang )
      return
    }*/

    // if is not storage load
    this.langeResource
      .setBaseUrl(getLanguageUrl(code))
      .fetchAll()
      .then(({ data }) => {
        const loadedLang = {
          code: code,
          data: data.data
        }
        this.props.setLocale(loadedLang)
      })
      .catch(err => console.log(err))
  }

  render() {
    const provider = {
      changeLanguage: this.changeLanguage.bind(this)
    }
    const isLogginPage = this.props.match.isExact && this.props.match.path === '/'
    const {
      history,
      visibleLockBackground,
      fileManager
    } = this.props
    const pagesWithoutHeader = this.props.location.pathname.match(/\/publish|welcome|first-magazine|404/)

    return (
      <CoreContext.Provider value={provider}>
        <Scripts />

        {/** CONTEXT MENU ON ITEMS */}
        {/* <ContextMenu /> */}

        {/* TOAST */}
        <Toast />

        {/* ALERTS */}
        <AlertModal />

        {/* LOCK BACKGROUND */}
        {visibleLockBackground.isVisible && <LockBackground />}

        
          <AuthComponent>
            {!pagesWithoutHeader && (
              <HeaderComponent isLogginPage={isLogginPage} history={history} />
            )}

            {/* OPEN FILE MANAGER */}
            {fileManager.isOpened && <FileManager />}

            <section className={styles.pages}>
              <Switch>
                <Route
                  exact
                  path="/"
                  component={
                    process.env.NODE_ENV === 'development'
                      ? LoginComponent
                      : () => window.location = `${process.env.REACT_APP_OFFICE_URL}/us/office/login`
                  }
                />
                <Route path="/check-auth/:token/:lang/:officeToken" component={checkAuth} />
                <AuthGuard path="/welcome" component={Welcome} />
                <AuthGuard path="/first-magazine" component={FirstMagazine} />
                <AuthGuard path="/dashboard" component={Dashboard} />
                <AuthGuard path="/magazines/:id" component={Editor} />
                <AuthGuard
                  path="/preview/:magazineId"
                  component={MagazinePreview}
                />
                <AuthGuard
                  path="/exported-magazines/:userId"
                  component={ExportedMagazines}
                />
                {isMobile.phone || isMobile.tablet || this.props.location.search.indexOf('mobile') > 0 ? (
                  <Route
                    path="/publish/:magazineId"
                    component={MobilePublishComponent}
                  />
                ) : (
                  <Route
                    path="/publish/:magazineId"
                    component={PublishComponent}
                  />
                )}
                <Route path="/404" component={PageNotFound} />
              </Switch>
            </section>
          </AuthComponent>

      </CoreContext.Provider>
    )
  }
}

const mapStateToProps = state => {
  const headerType = getHeaderMode(state)
  const visibleLockBackground = getLockBackground(state)
  const fileManager = getFileManager(state)
  return { headerType, visibleLockBackground, fileManager }
}
export default withRouter(
  connect(
    mapStateToProps,
    { setLocale }
  )(App)
)



// WEBPACK FOOTER //
// ./src/components/App.js